
import { defineComponent, ref, computed, toRef, watch } from "vue";
import { DataSet, Timeline } from "vis-timeline/standalone";
import "vis-timeline/styles/vis-timeline-graph2d.css";

import ReasonExplained from "@/components/modals/general/ReasonExplained.vue";
import NmiDetails from "@/components/merchants/chargebacks/view/NmiDetails.vue";
import USAEPayDetails from "@/components/merchants/chargebacks/view/USAEPayDetails.vue";
import SquareUp from "@/components/merchants/chargebacks/view/SquareUp.vue";
import FluidPayDetails from "@/components/merchants/chargebacks/view/FluidPayDetails.vue";
import NuveiDetails from "@/components/merchants/chargebacks/view/NuveiDetails.vue";

interface TimeLineItem {
  id: number;
  content: string;
  start: string;
}

export default defineComponent({
  name: "chargeback-details",
  components: {
    ReasonExplained,
    NmiDetails,
    USAEPayDetails,
    SquareUp,
    FluidPayDetails,
    NuveiDetails,
  },
  props: {
    reason: Object,
    reason_explained: Object,
    incoming: { type: Object, required: true },
    merchant: { type: Object, required: true },
  },
  setup(props) {
    const incomingData = toRef(props, "incoming");
    const timelineRef = ref<HTMLElement | null>(null);
    const options = ref({});
    const timeline = ref<Timeline | null>(null);

    const getDisputeCycleItems = computed(() => {
      const items: TimeLineItem[] = [];
      let id = 1;
      if (incomingData.value.dispute_date !== undefined) {
        items.push({
          id,
          content: "First Chargeback",
          start: incomingData.value.dispute_date,
        });
        id = id + 1;
      }

      if (
        incomingData.value.dispute_cycle.dispute_sent_status !== undefined &&
        incomingData.value.dispute_cycle.dispute_date_sent !== undefined
      ) {
        items.push({
          id,
          content: incomingData.value.dispute_cycle.dispute_sent_status,
          start: incomingData.value.dispute_cycle.dispute_date_sent,
        });
        id = id + 1;
      }

      if (
        incomingData.value.dispute_cycle.dispute_receieved_status !==
          undefined &&
        incomingData.value.dispute_cycle.dispute_received_date !== undefined
      ) {
        items.push({
          id,
          content: incomingData.value.dispute_cycle.dispute_receieved_status,
          start: incomingData.value.dispute_cycle.dispute_received_date,
        });
        id = id + 1;
      }

      if (
        incomingData.value.dispute_cycle.pre_arbitration_status !== undefined &&
        incomingData.value.dispute_cycle.pre_arbitration_date !== undefined
      ) {
        items.push({
          id,
          content: incomingData.value.dispute_cycle.pre_arbitration_status,
          start: incomingData.value.dispute_cycle.pre_arbitration_date,
        });
        id = id + 1;
      }

      if (
        incomingData.value.dispute_cycle.pre_arb_sent_status !== undefined &&
        incomingData.value.dispute_cycle.pre_arb_date_sent !== undefined
      ) {
        items.push({
          id,
          content: incomingData.value.dispute_cycle.pre_arb_sent_status,
          start: incomingData.value.dispute_cycle.pre_arb_date_sent,
        });
        id = id + 1;
      }

      if (
        incomingData.value.dispute_cycle.resolved_status !== undefined &&
        incomingData.value.dispute_cycle.resolved_date !== undefined
      ) {
        items.push({
          id,
          content: incomingData.value.dispute_cycle.resolved_status,
          start: incomingData.value.dispute_cycle.resolved_date,
        });
        id = id + 1;
      }

      return new DataSet(items);
    });

    watch(
      () => getDisputeCycleItems.value,
      () => {
        displayTimeline();
      }
    );

    const displayTimeline = () => {
      if (timelineRef.value !== null) {
        if (timeline.value === null) {
          timeline.value = new Timeline(
            timelineRef.value,
            getDisputeCycleItems.value,
            options.value
          );
        } else {
          timeline.value.setItems(getDisputeCycleItems.value);
        }
      }
    };

    return {
      timelineRef,
    };
  },
});
